import { render, staticRenderFns } from "./HotRanking.vue?vue&type=template&id=84dcb006&scoped=true"
import script from "./HotRanking.vue?vue&type=script&lang=js"
export * from "./HotRanking.vue?vue&type=script&lang=js"
import style0 from "./HotRanking.vue?vue&type=style&index=0&id=84dcb006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dcb006",
  null
  
)

export default component.exports